import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import ReviewRating from './ReviewRating';

export default class ReviewsModal extends Component
{
    constructor(props) {
        super(props);
        
        this.state = {

        };
        
        this.findProductCoverPhoto = this.findProductCoverPhoto.bind(this);
        this.findReviewAvatar = this.findReviewAvatar.bind(this);
        this.showReviews = this.showReviews.bind(this);
    }
    
    findProductCoverPhoto(tour)
    {
        if (!_.isEmpty(tour.cover_photo))
        {
            return tour.cover_photo.medium;
        }
        
        return '/images/placeholder-16-9.jpg';
    }
    
    findReviewAvatar(review)
    {
        if (!_.isEmpty(review.avatar))
        {
            return review.avatar;
        }
        
        return '/images/placeholder-avatar.jpeg';
    }
    
    showReviews()
    {
        this.setState({
            
        }, () => 
        {
            _$('#reviewsModal').modal('show');
        });
    }
    
    render()
    {
        const { tour } = this.props;
        
        return (
            <div>
                <button 
                    className="btn btn-rounded btn-outline-primary border-2p px-6 py-3 font-weight-bold"
                    onClick={() => {this.showReviews(tour)}}>
                    Show all {tour.reviews_count} reviews
                </button>
            
                <div id="reviewsModal" className="modal fade" tabIndex="-1" role="dialog" aria-hidden="true">
                    <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
                        <div className="modal-content vh-75">
                            <div className="modal-header border-bottom-0 p-4">
                                <div className="media">
                                    <div className="mr-4 align-self-center">
                                        <img className="img-fluid w-100" style={{ maxWidth: '150px' }} src={this.findProductCoverPhoto(tour)} />
                                    </div>
                                    <div className="media-body align-self-center">
                                        <div>
                                            {
                                                !_.isEmpty(tour.address) &&
                                                <div><span className="body-text-color font-smaller text-uppercase">{tour.address}</span></div>
                                            }
                                        
                                            <h4 className="body-font font-weight-bold">{tour.name}</h4>
                                            <ReviewRating 
                                                star_rating={tour.average_rating}
                                                count={tour.reviews_count}
                                            />
                                        </div>
                                    </div>
                                </div>
                                
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body pt-0 px-5 vh-65 overflow-y-auto">
                                <div className="row">
                                    <div className="col-12">
                                        {
                                            tour.reviews.data.map((review, key) => {

                                                return (
                                                    <div key={key} className="mb-5">
                                                        <div className="media mb-2">
                                                            <div className="mr-2 align-self-center">
                                                                <img className="avatar tiny-avatar border-3p border-white border-solid" src={this.findReviewAvatar(review)} />
                                                            </div>
                                                            <div className="media-body align-self-center">
                                                                <div className="font-weight-bold">{review.author}</div>
                                                            </div>
                                                        </div>

                                                        <div className="mb-3 mb-lg-4">
                                                            {review.comment}
                                                        </div>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./resources/js/components/Shared/ReviewsModal.js